<template>
  <v-row>
    <v-col sm="2">
      <v-text-field :label="$t('locations.name')" v-model="contact.name"></v-text-field>
    </v-col>
    <v-col sm="3">
      <v-text-field :label="$t('locations.surname')" v-model="contact.surname"></v-text-field>
    </v-col>
    <v-col sm="3">
      <v-text-field :label="$t('locations.email')" v-model="contact.email"></v-text-field>
    </v-col>
    <v-col sm="3">
      <v-text-field :label="$t('locations.phone_number')" v-model="contact.phone_number"></v-text-field>
    </v-col>
    <v-col sm="1">
      <v-btn text icon color="kazan" @click="removeContact()">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LocationFormContactItem',
  props: ['contact', 'index'],
  methods: {
    removeContact: function () {
      this.$emit('remove-contact', this.index)
    }
  }
}
</script>

<style>
</style>
